import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    haveSuggestion: string;
    submitFeedback: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Prompt text asking if user has a suggestion */
            haveSuggestion: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SubmitFeedback.haveSuggestion?c=nt784crgau0w", defaultMessage: "Have a suggestion?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button text to submit feedback */
            submitFeedback: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SubmitFeedback.submitFeedback?c=3ooxlga8hwjwg", defaultMessage: "Submit feedback" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
